import { useCallback, useEffect, useState } from 'react'
import { PageProps } from '..'
import { useProjectPrivateContext } from '../../context/projectContext'
import Auth from '../../../lib/commons/auth'
import store from '../../../store'
import { intl } from '../../../i18n'
import ProfitLossSummaryView from './view'
import { projectPrivate } from '../../higher-order-components/projectPrivate'
import { showAlert } from '../../../store/globalAlert'

type Props = PageProps

const ProfitLossSummary = (props: Props) => {
  const { project } = useProjectPrivateContext()
  const [initialized, setInitialized] = useState(false)
  const [certificated, setCertificated] = useState(false)

  const checkAuth = useCallback(async () => {
    try {
      const result = await Auth.checkAccountingAuth(
        project.uuid,
        props.externalId
      )
      setCertificated(result)
      if (!result) {
        store.dispatch(
          showAlert({
            message: intl.formatMessage({
              id: 'global.warning.unauthorized.function',
            }),
          })
        )
      }
    } finally {
      setInitialized(true)
    }
  }, [project, props.externalId])

  useEffect(() => {
    if (!initialized) {
      checkAuth()
    }
  }, [checkAuth, initialized])

  if (!certificated) return <></>
  return <ProfitLossSummaryView {...props} currentProject={project} />
}

export default projectPrivate(ProfitLossSummary)
